<template>
  <div class="mb-3">
    <v-card
      class="d-flex align-end flex-column"
      flat
      height="250px"
      style="overflow-y: scroll"
    >
      <v-card class="pa-0 ma-0" width="100%" flat>
        <v-container>
          <v-sheet
            ref="chatbox"
            color="transparent"
            :style="{ 'margin-bottom': '50px' }"
          >
            <v-row v-for="(message, index) in QuestionList" :key="index">
              <v-col
                v-if="message.type === 'carousel' || message.type === 'button'"
                cols="12"
                class="py-0"
              >
                <v-card
                  :class="`d-flex justify-end mb-1`"
                  color="transparent"
                  flat
                  tile
                >
                  <ComponentType :message="message" />
                </v-card>
              </v-col>
              <ButtonGroup
                v-if="message.type === 'quickReply'"
                :index="index"
                :message="message"
                :Editing="Editing"
                :QuestionList="QuestionList"
                :LastQuestion="LastQuestion"
              />
              <v-col v-else cols="12" class="py-0">
                <v-card
                  class="d-flex mb-2 mr-5 justify-end align-center"
                  flat
                  tile
                  color="transparent"
                >
                  <TextType
                    v-if="message.type === 'text'"
                    :index="index"
                    :message="message"
                    :Editing="Editing"
                    :QuestionList="QuestionList"
                    :LastQuestion="LastQuestion"
                  />
                  <ImageType
                    v-if="message.type === 'image'"
                    :index="index"
                    :message="message"
                    :Editing="Editing"
                    :QuestionList="QuestionList"
                    :LastQuestion="LastQuestion"
                  />
                  <VideoType
                    v-if="message.type === 'video'"
                    :index="index"
                    :message="message"
                    :Editing="Editing"
                    :QuestionList="QuestionList"
                    :LastQuestion="LastQuestion"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-sheet>
        </v-container>
        <div ref="bottomchat"></div>
      </v-card>
    </v-card>
    <Keyboard
      @bottom="ScrollToBottom"
      :questioninfo="questioninfo"
      :Editing="Editing"
    />
  </div>
</template>
<script>
import TextType from "./Text/TextType";
import ImageType from "./Image/ImageType";
import VideoType from "./Video/VideoType.vue";
import ButtonGroup from "./QuickReply/ButtonGroup";
import ComponentType from "./Components/ComponentType";
import Keyboard from "../Keyboard/Keyboard";
export default {
  props: ["questioninfo", "Editing"],
  components: {
    TextType,
    ImageType,
    ButtonGroup,
    ComponentType,
    Keyboard,
    VideoType,
  },
  data() {
    return {
      scrolloptions: { duration: 300, offset: 0, easing: "easeInOutCubic" },
    };
  },
  mounted() {
    // this.$vuetify.goTo(this.$refs.bottomchat, this.scrolloptions);
  },
  methods: {
    ScrollToBottom() {
      // const el = this.$refs.chatbox.$el;
      // console.log(el);
    },
  },
  computed: {
    QuestionList() {
      return this.questioninfo ? this.questioninfo.questions : [];
    },
    LastQuestion() {
      if (this.questioninfo) {
        let lastquestion =
          this.questioninfo.questions[this.questioninfo.questions.length - 1];
        if (lastquestion) {
          return lastquestion;
        }
      }
      return "";
    },
  },
};
</script>
